import React from "react";
import {
  Alert,
  Box,
  Button,
  Container,
  Link,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

const headerIconFrameSx = {
  width: 72,
  height: 72,
  borderRadius: 2,
  overflow: "hidden",
  flexShrink: 0,
};

const headerTitleSx = {
  fontWeight: 700,
  fontSize: { xs: "2rem", md: "3rem" },
  lineHeight: 1,
};

const IOS_ARUP_INSTALL_URL =
  "itms-services://?action=download-manifest&url=https://salmon-river-0c266d200.4.azurestaticapps.net/ios-arup/manifest-v1.0.0-54.1.plist";

const IOS_ANIMAE_INSTALL_URL =
  "itms-services://?action=download-manifest&url=https://salmon-river-0c266d200.4.azurestaticapps.net/ios/manifest.plist";

const isIosDevice = () =>
  /iPad|iPhone|iPod/.test(navigator.userAgent) ||
  (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

const releases = [
  {
    version: "v1.0.0(54.2 prod",
    date: "02/11/2026",
    notes: "",
    iosLabel: "",
    iosUrl: "",
    androidLabel: "SmartLog54_2_prod.apk",
    androidUrl:
      "https://salmon-river-0c266d200.4.azurestaticapps.net/android/SmartLog54_2_prod.apk",
  },
  {
    version: "55 dev",
    date: "29/10/2026",
    notes: "test ci ipa",
    iosLabel: "Install IPA",
    iosUrl: IOS_ARUP_INSTALL_URL,
    androidLabel: "",
    androidUrl: "",
  },
  {
    version: "v.1.0.0(54.2(dev 10/20 v3))",
    date: "29/09/2026",
    notes: "test ipa release",
    iosLabel: "Install IPA",
    iosUrl: IOS_ANIMAE_INSTALL_URL,
    androidLabel: "",
    androidUrl: "",
  },
  {
    version: "v.1.0.0(54)",
    date: "28/08/2026",
    notes: "Sketch enhancement and other improvements",
    iosLabel: "TestFlight",
    iosUrl: "https://testflight.apple.com/join/sjn4EDm1",
    androidLabel: "SmartLog54_0826_prod_app-release.apk",
    androidUrl:
      "https://www.dropbox.com/scl/fi/ks112v0ld5b8922j0um3l/PROD_SmartLog54_0826_prod_app-release.apk?rlkey=sygwopl91ny0x9kljqzgboale&st=hxtutm5o&dl=0",
  },
  {
    version: "v.1.0.0(53)",
    date: "20/07/2026",
    notes: "Trial Pit Sketching & Slope Stripping Updates",
    iosLabel: "TestFlight",
    iosUrl: "https://testflight.apple.com/join/sjn4EDm1",
    androidLabel: "SmartLog53_0717_prod_app-release.apk",
    androidUrl:
      "https://www.dropbox.com/scl/fi/83f8ldljaaejl7ptpmg5x/SmartLog53_0717_prod_app-release.apk?rlkey=gw1u2rdro77f33l5uwaehqy1z&st=il4bo5t5&dl=0",
  },
  {
    version: "v.1.0.0(51)",
    date: "09/04/2026",
    notes: "UI Revamp",
    iosLabel: "TestFlight",
    iosUrl: "https://testflight.apple.com/join/sjn4EDm1",
    androidLabel: "SmartLog51_0408_prod_app-release.apk",
    androidUrl:
      "https://www.dropbox.com/scl/fi/miexzxb4cg3e6lkjpxmty/SmartLog51_0408_prod_app-release.apk?rlkey=zaewdgginowqndw7pomv67xp7&st=zsz2co96&dl=0",
  },
  {
    version: "v.1.0.0(50)",
    date: "22/01/2026",
    notes: "UI Revamp",
    iosLabel: "TestFlight",
    iosUrl: "https://testflight.apple.com/join/sjn4EDm1",
    androidLabel: "SmartLog50_0120_prod_app-release.apk",
    androidUrl:
      "https://www.dropbox.com/scl/fi/km2sbsaojr7hh58udeyz9/SmartLog50_0120_prod_app-release.apk?rlkey=wq6906tc15bq8atc952trk34j&st=nq3kkcj3&dl=0",
  },
  {
    version: "v.1.0.0(49)",
    date: "04/11/2025",
    notes:
      "Data structure updates to HDPH, ISPT, DREM, FRAC & GEOL. Imrovements in Geological Descriptions.",
    iosLabel: "TestFlight",
    iosUrl: "https://testflight.apple.com/join/sjn4EDm1",
    androidLabel: "SmartLog49_1031_prod_app-release.apk",
    androidUrl:
      "https://www.dropbox.com/scl/fi/8nva3qglkvpq4qjboq40i/SmartLog49_1031_prod_app-release.apk?rlkey=x6ktprfsky2if3yahemcxrc15&st=dhhza00j&dl=0",
  },
  {
    version: "v.1.0.0(48)",
    date: "17/09/2025",
    notes: "Intermittent release",
    iosLabel: "TestFlight",
    iosUrl: "https://testflight.apple.com/join/sjn4EDm1",
    androidLabel: "SmartLog48_0917_prod_app-release.apk",
    androidUrl:
      "https://www.dropbox.com/scl/fi/ay9dsu8t7umfxggia4khq/SmartLog48_0917_prod_app-release.apk?rlkey=50h6nsunedgy72i73272uwvsu&st=pvn1cjd3&dl=0",
  },
  {
    version: "v.1.0.0(47)",
    date: "30/06/2025",
    notes: "Frontend fixes, AGS export improvements, plus xls export",
    iosLabel: "TestFlight",
    iosUrl: "https://testflight.apple.com/join/sjn4EDm1",
    androidLabel: "SmartLog47_0627_app-release.apk",
    androidUrl:
      "https://www.dropbox.com/scl/fi/6i20xa11d1xa4ez41dy9r/SmartLog47_0627_app-release.apk?rlkey=lzeydkaku8vjbl61kqyf9opm1&st=nyyab2xy&dl=0",
  },
  {
    version: "v.1.0.0(46)",
    date: "29/05/2025",
    notes:
      "Backend pipeline fixes, AGS data model and export improvements and more.",
    iosLabel: "TestFlight",
    iosUrl: "https://testflight.apple.com/join/sjn4EDm1",
    androidLabel: "SmartLog46_0529_app-release.apk",
    androidUrl:
      "https://www.dropbox.com/scl/fi/5i172jk51dqegurhb8rdl/SmartLog46_0529_app-release.apk?rlkey=bi1mehmnmfmqvtffaluzaph0q&st=n05h2g0y&dl=0",
  },
  {
    version: "v.1.0.0(45)",
    date: "08/04/2025",
    notes:
      "Trial Pit entries are now available with drawing functions as a preview.",
    iosLabel: "TestFlight",
    iosUrl: "https://testflight.apple.com/join/sjn4EDm1",
    androidLabel: "SmartLog-0120_v100(45).apk",
    androidUrl:
      "https://www.dropbox.com/scl/fi/lkmx9eqgf9ld0961ws3ne/SmartLog-0409_v100-45.apk?rlkey=5jqrqpgdfx32hmaih3erve1ly&st=i9kht87t&dl=0",
  },
  {
    version: "v.1.0.0(43)",
    date: "28/02/2025",
    notes: "Our biggest update yet with numerous bug fixes and UIX additions.",
    iosLabel: "TestFlight",
    iosUrl: "https://testflight.apple.com/join/sjn4EDm1",
    androidLabel: "SmartLog-0120_v100(43).apk",
    androidUrl:
      "https://www.dropbox.com/scl/fi/qrbkt0dfcrjgd5mzqbb2y/SmartLog-0228_v100-43.apk?rlkey=4vjpj7dcq5j515necuq1uwwkv&st=1hnats9e&dl=0",
  },
  {
    version: "v.1.0.0(40)",
    date: "20/01/2025",
    notes: "Reinstated save button",
    iosLabel: "TestFlight",
    iosUrl: "https://testflight.apple.com/join/sjn4EDm1",
    androidLabel: "SmartLog-0120_v100(40).apk",
    androidUrl:
      "https://www.dropbox.com/scl/fi/5j9fgbxhwze2cwucmi64i/SmartLog-0120_v100-40.apk?rlkey=5f1sp1et9oguy5f46d9d9c6xt&st=qhdjhqjj&dl=0",
  },
  {
    version: "v.1.0.0(39)",
    date: "30/12/2024",
    notes: "Enlarged homepage logo",
    iosLabel: "TestFlight",
    iosUrl: "https://testflight.apple.com/join/sjn4EDm1",
    androidLabel: "SmartLog-1230_v100(39).apk",
    androidUrl:
      "https://www.dropbox.com/scl/fi/16c58jvsufk14r42bhg6k/SmartLog-1230_v100-39.apk?rlkey=k4gv5eldozun8tpzkjoybgvp3&st=uqbkt80e&dl=0",
  },
  {
    version: "v1.0.0(35)",
    date: "29/11/2024",
    notes: "Streamlined UIX, detailed description, improved AGS exports",
    iosLabel: "TestFlight",
    iosUrl: "https://testflight.apple.com/join/sjn4EDm1",
    androidLabel: "GIMobile-1129_v100(35).apk",
    androidUrl:
      "https://www.dropbox.com/scl/fi/huhdlmw2y9h1zeqqkevwd/GIMobile-1129_v100-35.apk?rlkey=nmm0gc5hpfs8q968gtprlenxb&st=lao1jjo2&dl=0",
  },
  {
    version: "v1.0.0(34)",
    date: "29/10/2024",
    notes:
      "Gallery UI, dynamic depth intervals, API optimisation, daily water record UI improvement",
    iosLabel: "TestFlight",
    iosUrl: "https://testflight.apple.com/join/sjn4EDm1",
    androidLabel: "GIMobile-1025_v100(34).apk",
    androidUrl:
      "https://www.dropbox.com/scl/fi/w6ifc62nrirubnucny25b/GIMobile-1025_v100-34.apk?rlkey=muo2m7izpc90wf47hcbts4pwp&st=do0dnzhr&dl=0",
  },
  {
    version: "v1.0.0(33)",
    date: "27/09/2024",
    notes:
      "AGS4.0 export function, loading UI, periodic syncing with cloud server, network capacity improvements, off-line first capability",
    iosLabel: "TestFlight",
    iosUrl: "https://testflight.apple.com/join/sjn4EDm1",
    androidLabel: "GIMobile-0923_v100(33).apk",
    androidUrl:
      "https://www.dropbox.com/scl/fi/se3pnincqhnbo6tllm5j5/GIMobile-0823_v100-33.apk?rlkey=a8mxzh1w910mjtz50ueiip9zf&st=fmkl5eau&dl=0",
  },
  {
    version: "v.1.0.0(32)",
    date: "29/08/2024",
    notes:
      "update data structure to AGS4.0.2 compatibility, automatic calculation of casing depth",
    iosLabel: "TestFlight",
    iosUrl: "https://testflight.apple.com/join/sjn4EDm1",
    androidLabel: "GIMobile-0723_v100(32).apk",
    androidUrl:
      "https://www.dropbox.com/scl/fi/9bfifhusg1ezpbn1dnf61/GIMobile-0823_v100-32.apk?rlkey=o6vixw2wa3onw58t0oenxzhqn&st=i4nk3txf&dl=0",
  },
  {
    version: "v.1.0.0(31)",
    date: "22/07/2024",
    notes:
      "as-built information editable, all actions saved locally, removed save button, updated app icon, data validation with warning",
    iosLabel: "TestFlight",
    iosUrl: "https://testflight.apple.com/join/sjn4EDm1",
    androidLabel: "GIMobile-0722_v100(31).apk",
    androidUrl:
      "https://www.dropbox.com/scl/fi/ync4l0ichu45kczenqw10/GIMobile-0722_v100-31.apk?rlkey=y489g1bo95rtihgzazwz6n83v&st=g3jl9uz5&dl=0",
  },
  {
    version: "v.1.0.0(30)",
    date: "26/06/2024",
    notes:
      "undo, automatic saving, swipe left to delete project, SPT penetration editable",
    iosLabel: "TestFlight",
    iosUrl: "https://testflight.apple.com/join/sjn4EDm1",
    androidLabel: "GIMobile-0625_v100(30).apk",
    androidUrl:
      "https://www.dropbox.com/scl/fi/krtad0xlxam2wu6wkdey4/GIMobile-0625_v100-30.apk?rlkey=cl6pd6tckhy4pppnfh67qguz2&st=myciuknz&dl=0",
  },
  {
    version: "v.1.0.0(29)",
    date: "31/05/2024",
    notes: "None",
    iosLabel: "TestFlight",
    iosUrl: "https://testflight.apple.com/join/sjn4EDm1",
    androidLabel: "GIMobile-0320_v100(29).apk",
    androidUrl:
      "https://www.dropbox.com/scl/fi/31uht0rem9guuafp5y5h4/GIMobile-0320_v100-29.apk?rlkey=zflmalrtqj4wyep6fc4duya9v&st=p3f0vf9j&dl=0",
  },
];

const ReleasesView = () => {
  const canInstallIosApp = isIosDevice();

  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Paper elevation={0} sx={{ p: { xs: 3, md: 5 }, borderRadius: 4 }}>
        <Stack spacing={3}>
          <Box display="flex" alignItems="center" gap={2}>
            <Box sx={headerIconFrameSx}>
              <Box
                component="img"
                alt="SmartLog"
                src="assets/logos/SmartLog.png"
                sx={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            </Box>
            <Box>
              <Typography variant="h3" sx={headerTitleSx}>
                Releases
              </Typography>
              <Typography color="text.secondary">
                Current release information and testing links.
              </Typography>
            </Box>
          </Box>

          <Box
            sx={{
              borderTop: 1,
              borderBottom: 1,
              borderColor: "divider",
              py: 3,
            }}
          >
            <Stack spacing={2} alignItems="flex-start">
              <Box>
                <Typography variant="h5" fontWeight={700}>
                  SmartLog iOS
                </Typography>
                <Typography color="text.secondary">
                  Version 54.2(dev 10/20 v3)
                </Typography>
                <Typography color="text.secondary">
                  Bundle ID: com.arup.geo-inspect-ipa
                </Typography>
              </Box>

              <Button
                component="a"
                variant="contained"
                href={canInstallIosApp ? IOS_ANIMAE_INSTALL_URL : undefined}
                disabled={!canInstallIosApp}
              >
                Install SmartLog
              </Button>

              {!canInstallIosApp && (
                <Alert severity="info">
                  This installation link only works on iPhone and iPad.
                </Alert>
              )}
            </Stack>
          </Box>

          <Typography>User manual (TBD)</Typography>

          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Version</TableCell>
                <TableCell>iOS</TableCell>
                <TableCell>Android</TableCell>
                <TableCell>Date</TableCell>
                <TableCell>Notes</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {releases.map((release) => (
                <TableRow key={release.version}>
                  <TableCell>{release.version}</TableCell>
                  <TableCell>
                    {release.iosUrl ? (
                      <Link
                        href={release.iosUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {release.iosLabel}
                      </Link>
                    ) : (
                      release.iosLabel
                    )}
                  </TableCell>
                  <TableCell>
                    {release.androidUrl ? (
                      <Link
                        href={release.androidUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {release.androidLabel}
                      </Link>
                    ) : (
                      release.androidLabel
                    )}
                  </TableCell>
                  <TableCell>{release.date}</TableCell>
                  <TableCell>{release.notes}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Stack>
      </Paper>
    </Container>
  );
};

export default ReleasesView;
